import * as types from './types';
export default {
  [types.SET_DESCRIPTION](state, payload) {
    const currentState = state;
    currentState.description = payload;
  },

  [types.RESET_CATEGORY](state) {
    const currentState = state;
    currentState.total = null;
    currentState.products = null;
    currentState.description = null;
  },

  [types.SET_PRODUCTS](state, _ref) {
    let {
      products,
      total
    } = _ref;
    const currentState = state;
    currentState.total = total;
    currentState.products = products;
  },

  [types.APPEND_PRODUCTS](state, payload) {
    const currentState = state;
    const products = currentState.products.map(e => Object.assign(e, {
      old: true
    }));
    currentState.products = [...products, ...payload];
  },

  [types.PREPEND_PRODUCTS](state, payload) {
    const currentState = state;
    const products = currentState.products.map(e => Object.assign(e, {
      old: true
    }));
    currentState.products = [...payload, ...products];
  }

};